import React, {Component}               from 'react';
import PropTypes                        from 'prop-types';
import classNames                       from 'classnames';
import FaCheck                          from 'react-icons/lib/fa/check';
import HelpIcon                         from './Fragments/HelpIcon';
import AddressInput                     from './Fields/AddressInput';
import ButtonChoiceInput                from './Fields/ButtonChoiceInput';
import CheckboxGroupInput               from './Fields/CheckboxGroupInput';
import CheckboxInput                    from './Fields/CheckboxInput';
import ChildQuestion                    from './Fields/ChildQuestion';
import DateInput                        from './Fields/DateInput';
import EmailInput                       from './Fields/EmailInput';
import HiddenInput                      from './Fields/HiddenInput';
import MoneyInput                       from './Fields/MoneyInput';
import NumberInput                      from './Fields/NumberInput';
import PasswordInput                    from './Fields/PasswordInput';
import RadioGroupInput                  from './Fields/RadioGroupInput';
import SelectInput                      from './Fields/SelectInput';
import SortcodeInput                    from './Fields/SortcodeInput';
import TextInput                        from './Fields/TextInput';
import PostcodeInput                    from './Fields/PostcodeInput';
import TextInputWithSelectionList       from './Fields/TextInputWithSelectionList';
import TextareaInput                    from './Fields/TextareaInput';
import UploadInput                      from './Fields/UploadInput';

let Quote = require('./Managers/Quote.js');
const objectPath = require("object-path");

class Field extends Component {
    /**
     * Set initial state.
     *
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            isHelpVisible: false,
            isAnswerAcceptable: false,
            hasError: false,
            isValid: false,
            isTickVisible: true,
            isModalVisible: false,
            showHelpIcon: this.props.showHelpIcon,
            layoutClass: this.props.layoutClass,
        };
    }

    getWrappingField() {
        return this;
    }

    /**
     * Toggle the visibility of help icon and text, or force a visibility state
     * if boolean provided.
     *
     * @param v
     */
    toggleHelpIcon(v) {
        if (window.uornorb(v)) {
            this.setState({ showHelpIcon: !this.state.showHelpIcon });
        } else {
            this.setState({ showHelpIcon: v });
        }
    }

    /**
     * Renders out the desired field type based on props passed to this component.
     *
     * @returns {XML}
     */
    renderField() {

        /**
         * we cant just assign this.props to a variable, as that passes by reference
         * so we create a new object with a reference to this, then assign
         * all the props into it, then load our child component with that
         * NEW set of props. this means every child component can use
         * "this.props.wrapperField" to get the instance of the Field that
         * is containing it
         *
         * this is useful for having the individual components do things that affect
         * the field that loaded them e.g hiding help icons, etc.
         */

        let props = {
            wrapperField: this.getWrappingField(),
        };

        Object.assign(props, this.props);

        // Load in a default value for the field if we can get the associated
        // answer form localStorage.
        let defaultValue;

        // 1. attempt to load using the loadingKey first, as thats probably set to
        //    inside BaseIndividualApplication
        if (this.props.loadValues === true && window.uornorb(defaultValue) && this.props.loadingKey) {
            let masterKey = this.props.loadingKey.split('.')[0];
            let masterObject = JSON.parse(window.localStorage.getItem(masterKey));
            let loadingKey = this.props.loadingKey.replace(masterKey + '.', '');
            defaultValue = objectPath.get(masterObject, loadingKey);
        }

        // 2. if that doesnt work, try using just the storageKey and source
        if (window.uorn(defaultValue) && this.props.loadValues === true && Quote.get(this.props.storageKey, this.props.source) !== null) {
            defaultValue = Quote.get(this.props.storageKey, this.props.source);
        }

        // 3. if that still doesnt work, its probably an address which means we have
        //    to deal with more bullshit
        if (this.props.type === 'address' && this.props.loadValues === true && window.uorn(defaultValue)) {
            let masterKey = this.props.source.split('.')[0];
            let masterObject = JSON.parse(window.localStorage.getItem(masterKey));
            let loadingKey = this.props.source.replace(masterKey + '.', '');
            defaultValue = objectPath.get(masterObject, loadingKey);
        }

        // 4. finally, it might be a control we dont actually save. in that
        //    case, run a function to get its value
        if (this.props.overwriteDefaultValue && this.props.loadValues) {
            defaultValue = this.props.overwriteDefaultValue();
        }

        switch (this.props.type) {
            case 'address':
                return <AddressInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'button-choice':
                return <ButtonChoiceInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'checkbox':
                return <CheckboxInput {...props} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'checkbox-group':
                return <CheckboxGroupInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'date':
                return <DateInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'email':
                return <EmailInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'hidden':
                return <HiddenInput {...props} />;
            case 'money':
                return <MoneyInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'number':
                return <NumberInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'password':
                return <PasswordInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} ref={(instance) => {this.childComponent = instance;}} />;
            case 'radio-group':
                return <RadioGroupInput {...props} isTickVisible={this.isTickVisible.bind(this, false)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'select':
                return <SelectInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'sortcode':
                return <SortcodeInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'text':
                return <TextInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'postcode':
                return <PostcodeInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'text-with-selection-list':
                return <TextInputWithSelectionList {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'textarea':
                return <TextareaInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
            case 'upload':
                return <UploadInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} ref={(instance) => {this.childComponent = instance;}} />;
            default:
                // Default to text field if type has not been identified
                return <TextInput {...props} isTickVisible={this.isTickVisible.bind(this)} isValid={this.isValid.bind(this)} defaultValue={defaultValue} ref={(instance) => {this.childComponent = instance;}} />;
        }
    }

    getChildInstance() {
        return this.childComponent;
    }

    getChildInputComponents() {
        return this.childComponent.getChildInputComponents();
    }

    /**
     * Renders out the field title at the appropriate level.
     *
     * @returns {XML}
     */
    renderTitle() {
        let t = this.props.fieldTitle;
        if (t) {
            switch (this.props.titleLevel) {
                case 3:
                    return( <h3 className="question-title">{t}</h3> );
                case 4:
                    return( <h4 className="question-title">{t}</h4> );
                case 5:
                    return( <h5 className="question-title">{t}</h5> );
                default:
                    // Default to <h2> if 3-5 is not passed
                    return( <h2 className="question-title">{t}</h2> );
            }
        }
    }

    /**
     * Renders modal options if they are passed in from the parent component.
     *
     * @returns {XML}
     */
    renderModalOptions() {
        if (this.props.modalOptions.title) {
            return(
                <div>
                    {this.props.modalOptions.description} <a onClick={this.toggleVisibility.bind(this, 'modal')} className="underline">{this.props.modalOptions.trigger}</a>
                </div>
            );
        }
    }

    /**
     * Toggle visibility state on various sub-components.
     */
    toggleVisibility(v) {
        switch (v) {
            case 'modal':
                this.setState({
                    isModalVisible: (this.state.isModalVisible) ? false : true,
                });
                document.body.classList.toggle('no-scroll');
                break;
            case 'help':
                this.setState({
                    isHelpVisible: (this.state.isHelpVisible) ? false : true,
                });
                break;
        }
    }

    /**
     * Check modal options for the given parameters. Forces default behaviour if
     * the desired params are undefined.
     *
     * @param v
     * @returns {boolean}
     */
    checkModalOptions(v) {
        switch (v) {
            case 'footer':
                if (this.props.modalOptions.hasFooter === true || typeof this.props.modalOptions.hasFooter === 'undefined') {
                    return true;
                }
                break;
            case 'alert':
                if (this.props.modalOptions.isAlert === true || typeof this.props.modalOptions.isAlert === 'undefined') {
                    return false;
                }
                break;
        }
    }

    /**
     * Set state of the component isValid to true or false.
     *
     * @param v
     */
    isValid(v, val) {
        if (this.childComponent) {
            if (window.uorn(val)) {
                val = objectPath.get(this.childComponent, 'props.defaultValue', null);
                if (window.uornorb(val)) {
                    val = objectPath.get(this.childComponent, 'state.activeValue', null);
                }
                if (window.uornorb(val) && this.childComponent.getCurrentValue) {
                    val = this.childComponent.getCurrentValue();
                }

                // because dates and react === weird
                if (String(val) == 'Invalid date') {
                    val = null;
                }
            }

            // give a final chance to mark things as invalid
            if (this.props.inValidOverride && v == true) {
                let validationState = this.props.inValidOverride();
                v = validationState.isValid;
                this.childComponent.setState(validationState);
            }

            if (v && window.uornorb(val)) {
                this.setState({
                    isTickVisible: false
                });
            } else {
                this.setState({
                    isTickVisible: true
                });
            }
        }

        if (v === true) {
            this.setState({ isValid: true });
        } else {
            this.setState({ isValid: false });
        }
    }

    isTickVisible(flag) {
        this.setState({
            isTickVisible: flag
        });
    }

    setLayoutClass(className) {
        this.setState({ layoutClass: className });
    }

    addLayoutClass(className) {
        this.setState({
            layoutClass: this.state.layoutClass + ' ' + String(className)
        });
    }

    removeLayoutClass(className) {
        this.setState({
            layoutClass: this.state.layoutClass.replace(className, "")
        });
    }

    /**
     * Return the component
     *
     * @returns {XML}
     */
    render() {
        let FaCross = require('react-icons/lib/fa/close');

        // Load in any layoutClass passed into the component.
        let layoutClass = '';
        if (this.state.layoutClass) {
            layoutClass = this.state.layoutClass;
        }

        // Row classes to be applied to the <question-row> element.
        let rowClasses = classNames({
            'has-border': this.props.hasBorder,
            'has-padding': this.props.hasPadding,
            'is-small': this.props.isSmall,
            [`${layoutClass}`] : true, // well this is gross https://www.npmjs.com/package/classnames#dynamic-class-names-with-es2015
            'has-error': this.state.isValid === false ? true : false,
            'has-extra': this.state.isTickVisible === true ? true : false,
        });

        // Modal classes to apply to any modals fired by this component.
        let modalClasses = classNames({
            'modal': true,
            'has-footer': this.checkModalOptions('footer'),
            'alert': this.checkModalOptions('alert'),
        });

        let questionTopClasses = classNames({
            'question-top': true,
            'has-help': this.props.helpText ? true : false,
        });

        return(
            <div className={this.props.hasAlternateBackground === true ? 'alternate-background' : null}>
                <question-row class={rowClasses}>
                    <div className="question-main">
                        {this.props.type !== 'checkbox' ?
                            <div className={questionTopClasses}>
                                <div className="descriptor">
                                    {this.props.fieldTitle ?
                                        this.renderTitle()
                                    : null}

                                    {this.props.type !== 'address' && this.props.type !== 'hidden' ?
                                        <label htmlFor={this.props.fieldName}>{this.props.question}</label>
                                    : null}

                                    {this.renderModalOptions()}
                                </div>

                                <div className="assistance">
                                    {this.props.helpText && this.state.showHelpIcon ?  <HelpIcon onClick={this.toggleVisibility.bind(this, 'help')} /> : null }
                                </div>
                            </div>
                        : null}
                        {this.props.labelExtra ?
                            <div className="supplemental label-supplemental" dangerouslySetInnerHTML={{__html: this.props.labelExtra}} />
                        : null}

                        {this.renderField()}

                        {this.props.inputExtra ?
                            <div className="supplemental input-supplemental" dangerouslySetInnerHTML={{__html: this.props.inputExtra}} />
                        : null}

                        {this.state.isHelpVisible ? (
                            <div className="hint-container">
                                <div className="hint" dangerouslySetInnerHTML={{__html: '<div class="arrow arrow-left"></div>' + this.props.helpText}} />
                            </div>
                        ) : null}

                        {this.props.children ?
                            <ChildQuestion {...this.props} />
                        : null}
                    </div>

                    {this.state.isTickVisible && this.state.isValid ?
                        <div className="question-extra">
                            <div className="question-validation">
                                <FaCheck />
                            </div>
                        </div>
                    : null}
                </question-row>

                {this.props.modalOptions ?
                    <div className={this.state.isModalVisible ? 'modal-container modal-active' : 'modal-container'}>
                        <div className={modalClasses}>
                            <div className="modal-header">
                                {this.props.modalOptions.title}
                                <div className="close-cross" onClick={this.toggleVisibility.bind(this, 'modal')}>
                                    <FaCross className="pointer" />
                                </div>
                            </div>

                            <div className="modal-body">
                                <div className="content" dangerouslySetInnerHTML={{__html: this.props.modalOptions.content}} />
                            </div>

                            {this.checkModalOptions('footer') ?
                                <div className="modal-footer">
                                    <a onClick={this.toggleVisibility.bind(this, 'modal')} className="btn btn-default">Close</a>
                                </div>
                            : null}
                        </div>
                    </div>
                : null}
            </div>
        );
    }
}

/**
 * @type {{
     *   fieldName: Name for the field. Also used as the id attribute. i.e. don't use spaces,
     *   type: Type of field to load - defines the field component to use, default 'text',
     *   subType: sub-type (e.g. for different date types),
     *   question: question as it appears to the user,
     *   source: localStorage object to store values against,
     *   options: all the options to load in - used in fields like ButtonChoice etc.,
     *   renderOptionsAs: allow mutation of how options are displayed from the default,
     *   children: child/dependent questions to the current one,
     *   callbackFunction: method to pass back up the chain to the parent/grandparent/so on,
     *   maxLength: set a maximum length for text input fields,
     *   dataValidation: validation rule to apply to the field,
     *   defaultText: default text to show with the field (used in <select>),
     *   defaultValue: default value assigned to the defaultText of a field (used in <select>),
     *   placeholder: HTML5 placeholder text for inputs,
     *   inputMask: mask applied to input elements,
     *   addressOptions:
     *     pafLookup - search postcode - required, default true,
     *     canHaveManualEntry - allow manual entry on failed postcode look up,
     *     canBeForeign - allow selection of country, remove validation on postcode
     *   allowFileUploads: allow upload fields to use files,
     *   allowCameraUploads: allow upload fields to use the device's camera-roll,
     *   limitMonths: restrict month entry to 11 - more than this is for the year field, no?
     *   onUnmount: method to run when the component is unmounted
     *   isInt: if values are always to be parsed as integers
     *   hasAlternateBackground: display field container with the alternate background colour,
     *   hasBorder: display a border for the field, default true,
     *   hasPadding: if the field padded on top and bottom, default true,
     *   fieldTitle: title to display above the field label as an <h2-6> element,
     *   titleLevel: level for the title, default 2,
     *   helpText: help text associated with the field, triggered via an info icon click,
     *   labelExtra: supplemental text to show under the question label,
     *   inputExtra: supplemental text to show under the field input,
     *   layoutClass: pass in an additional className to override the default look of the field row. Applied to <question-row>,
     *   modalOptions:
     *     title: title to show in the modal,
     *     content: content text for the modal,
     *     description: descriptive/supplemental text to the modal rendered under the form field,
     *     trigger: text for the link that will trigger the modal to be displayed,
     *     hasFooter: add a footer to the modal with a close/accept button, default true,
     *     isAlert: flags the modal as an alert, which makes it harder to dismiss and styles it slightly different, default false
     * }}
 */
Field.propTypes = {
    // Functional props
    fieldName:              PropTypes.string.isRequired,
    type:                   PropTypes.string.isRequired,
    storageKey:             PropTypes.string,
    subType:                PropTypes.string,
    question:               PropTypes.string.isRequired,
    source:                 PropTypes.string,
    options:                PropTypes.array,
    renderOptionsAs:        PropTypes.string,
    children:               PropTypes.array,
    callbackFunction:       PropTypes.func,
    loadingKey:             PropTypes.string,
    overwriteDefaultValue:  PropTypes.func,
    inValidOverride:        PropTypes.func,
    onKeyUpFunc:            PropTypes.func,
    maxLength:              PropTypes.number,
    dataValidation:         PropTypes.string,
    defaultText:            PropTypes.string,
    defaultValue:           PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    placeholder:            PropTypes.string,
    inputMask:              PropTypes.string,
    addressOptions:         PropTypes.shape({
        pafLookup:              PropTypes.bool.isRequired,
        canHaveManualEntry:     PropTypes.bool,
        canBeForeign:           PropTypes.bool,
    }),
    allowFileUploads:       PropTypes.bool,
    allowCameraUploads:     PropTypes.bool,
    limitMonths:            PropTypes.bool,
    onUnmount:              PropTypes.func,
    isInt:                  PropTypes.bool,

    // Visual props
    hasAlternateBackground: PropTypes.bool,
    hasBorder:              PropTypes.bool,
    hasPadding:             PropTypes.bool,
    loadValues:             PropTypes.bool,
    idLabelFirst:           PropTypes.bool,
    fieldTitle:             PropTypes.string,
    titleLevel:             PropTypes.number,
    helpText:               PropTypes.string,
    labelExtra:             PropTypes.string,
    inputExtra:             PropTypes.string,
    displayTenancyMessage:  PropTypes.bool,
    layoutClass:            PropTypes.string,
    showHelpIcon:           PropTypes.bool,
    isSmall:                PropTypes.bool,
    modalOptions:           PropTypes.shape({
        title:                  PropTypes.string,
        content:                PropTypes.string,
        description:            PropTypes.string,
        trigger:                PropTypes.string,
        hasFooter:              PropTypes.bool,
        isAlert:                PropTypes.bool,
    }),
    questionBorder:         PropTypes.bool,
    questionContent:        PropTypes.string,
};

/**
 * We pass in a default type of 'text', being the simplest input type.
 * Default display props for fields is with a border and with padding,
 * though this can be overridden on a per-field basis.
 *
 * @type {{type: string, hasBorder: boolean, hasPadding: boolean}}
 */
Field.defaultProps = {
    type: 'text',
    hasBorder: true,
    hasPadding: true,
    titleLevel: 2,
    showHelpIcon: true,
    loadValues: false,
    isSmall: false,
    labelExtra: '',
    inputExtra: '',
    helpText: '',
    modalOptions: {
        hasFooter: true,
        isAlert: false,
        content: '',
    },
};

export default Field;



// WEBPACK FOOTER //
// ./src/components/Field.js